import { apiGetUserAssets } from "@/models/mall"
import { PropType } from '@/constants/mall'


const MUTATION_TYPE = {
  SET_ALL_ASSETS: 'SET_ALL_ASSETS',
}

const assets = {
  namespaced: true,
  state: {
    allAssets: [],
  },
  getters: {
    // 重置券
    resetCoupons(state) {
      return state.allAssets.filter((item) => item.typeInfo?.type === PropType.RESET)
    },
    // 增加次数券
    addCoupons(state) {
      return state.allAssets.filter((item) => item.typeInfo?.type === PropType.NUM)
    },
    // 延迟锁课卷
    delayCoupons(state) {
      return state.allAssets.filter((item) => item.typeInfo?.type === PropType.DELAY) || []
    },
  },
  mutations: {
    [MUTATION_TYPE.SET_ALL_ASSETS](state, data) {
      state.allAssets = data
    },
  },
  actions: {
    async getUserAssets({ commit }) {
			try {
				const res = await apiGetUserAssets()
				commit(MUTATION_TYPE.SET_ALL_ASSETS, res.data || [])
			} catch (error) {
				console.error(error)
			}
		},
  },
}

export default assets
